import { setDeep } from '@shared/utils';

const applyPrefsPendingMutations = ({ prefs = {}, pendingMutations = [] } = {}) => {
  return (Array.isArray(pendingMutations) ? pendingMutations : []).reduce(
    (nextPrefs, mutation) => {
      const path = String(mutation?.path || '').trim();

      if (!path) {
        return nextPrefs;
      }

      return setDeep(nextPrefs, path, mutation?.value);
    },
    prefs && typeof prefs === 'object' ? prefs : {}
  );
};

export default applyPrefsPendingMutations;
